import { useForm } from "@inertiajs/react";
import Input from "@/components/inputs/Input";
import Button from "@/components/buttons/Button";
import React from "react";
import FormActions from "@/components/buttons/FormActions";

const SignIn: React.FC = () => {
  const { data, setData, post, processing, errors } = useForm({
    email: "",
    password: "",
    remember_me: "1",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post("/users/sign_in");
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex w-full flex-col items-start justify-start gap-8 rounded-lg md:p-10"
    >
      <h1 className="font-serif text-2xl font-bold lg:text-4xl">Sign In</h1>
      <Input
        type="text"
        value={data.email}
        onChange={(e) => setData("email", e.target.value)}
        placeholder="Email"
        errors={errors.email}
        label="Email"
      />
      <Input
        type="password"
        value={data.password}
        onChange={(e) => setData("password", e.target.value)}
        placeholder="Password"
        errors={errors.password}
        label="Password"
      />
      <div className="flex w-full items-center gap-2">
        <label
          htmlFor="remember_me"
          className="text-cream-800 dark:text-cream-400 flex w-fit cursor-pointer items-center gap-2 text-sm font-medium select-none"
        >
          <input
            type="checkbox"
            id="remember_me"
            checked={data.remember_me === "1"}
            onChange={(e) =>
              setData("remember_me", e.target.checked ? "1" : "")
            }
            className="border-cream-500 text-peach-500 dark:bg-cream-800 dark:border-cream-500 dark:checked:bg-peach-500 dark:checked:border-peach-500 h-5 w-5 cursor-pointer rounded-md transition-all duration-150"
          />
          Remember me
        </label>
      </div>
      <FormActions>
        <Button type="primary" text="Sign In" disabled={processing} />
      </FormActions>
    </form>
  );
};

export default SignIn;
